import React from 'react';
import MarketplaceAdminBillPdf from '../../marketplace/marketplaceAdminBillPdf';
import { useBill } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';

const AdminBillView = ({ match }) => {
  const { isLoading, isError, error, bill } = useBill({
    billId: match.params.billId,
  });

  return (
    <div className="community-view__panel">
      <div className="community-view__panel-corner">
        <i className="fa fa-receipt" />
      </div>

      <Loader show={isLoading} />
      {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

      {bill ? (
        <div className="admin__bill">
          <MarketplaceAdminBillPdf bill={bill} />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default AdminBillView;
